import React from 'react'
import { Outlet } from 'react-router-dom'
import Footer from './Footer'
import Header from './Header'

const Layout = () => {
  return (
    <div>
        <Header/>
        <div>
        <Outlet/>
        </div>
        <div>
        <Footer/>
        </div>
    </div>
  )
}

export default Layout
